/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Api_Keys_TitleInputs */

const en_directory_integrate_api_keys_title = /** @type {(inputs: Directory_Integrate_Api_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage API keys`)
};

const zh_directory_integrate_api_keys_title = /** @type {(inputs: Directory_Integrate_Api_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理 API 密钥`)
};

/**
* | output |
* | --- |
* | "Manage API keys" |
*
* @param {Directory_Integrate_Api_Keys_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_api_keys_title = /** @type {((inputs?: Directory_Integrate_Api_Keys_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Api_Keys_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_api_keys_title(inputs)
	return zh_directory_integrate_api_keys_title(inputs)
});
export { directory_integrate_api_keys_title as "directory.integrate.api_keys.title" }